var render, staticRenderFns
import script from "./btnConfig.vue?vue&type=script&lang=js"
export * from "./btnConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e65c7d')) {
      api.createRecord('62e65c7d', component.options)
    } else {
      api.reload('62e65c7d', component.options)
    }
    
  }
}
component.options.__file = "found/views/config_center/view/list/btnConfig/btnConfig.vue"
export default component.exports